// extracted by mini-css-extract-plugin
export default {"loader":"AboutUsPage_loader__1Zkxi","error":"AboutUsPage_error__R-m5p"};